import { produce } from 'immer'
import { RemoteConfigResponse } from 'src/models/remoteConfig.models'
import {
  GET_REMOTE_CONFIG_SUCCESS,
  GetRemoteConfigActions,
  LOAD_FEATURE_FLAGS_SUCCESS,
  LoadFeatureFlagsActions,
  UPDATE_FEATURE_FLAG_SUCCESS,
  UpdateFeatureFlagActions,
} from 'src/redux/actions/session.actions'

export type Actions =
  | LoadFeatureFlagsActions
  | UpdateFeatureFlagActions
  | GetRemoteConfigActions

const FeatureFlaggerReducer = (
  state: Partial<RemoteConfigResponse>,
  action: Actions,
): Partial<RemoteConfigResponse> => {
  return produce(state, (draft) => {
    switch (action.type) {
      case UPDATE_FEATURE_FLAG_SUCCESS: {
        const newFeatureFlag = {
          [action.payload.featureFlag]: action.payload.val,
        }
        return { ...draft, ...newFeatureFlag }
      }

      case GET_REMOTE_CONFIG_SUCCESS: {
        draft = action.payload
        return draft
      }

      case LOAD_FEATURE_FLAGS_SUCCESS: {
        const newFeatureFlags = Object.keys(action.payload).reduce(
          (acc, curr) => ({
            ...acc,
            [curr]: action.payload[curr as keyof RemoteConfigResponse],
          }),
          {} as RemoteConfigResponse,
        )

        draft = {
          ...draft,
          ...newFeatureFlags,
        }
        return draft
      }
    }
  })
}

export default FeatureFlaggerReducer
